import { getAppointment } from "@/Services/TherapyApi/Schedule";
import AppointmentTransformer from "@/Modules/Transformers/Appointment";

import useScheduleStore from "@/Modules/Schedule/Store";

import { danger } from "@/Utils/Debug";
import type { Appointment } from "@/Modules/Models/Domain/Schedule";

async function getAppointmentsAH(uuid: string): Promise<Appointment | undefined> {
  const scheduleStore = useScheduleStore();

  scheduleStore.isLoading = true;

  let appointmentDomain;

  try {
    const appointmentResp = await getAppointment(uuid);

    appointmentDomain = AppointmentTransformer.toDomain(appointmentResp);

    scheduleStore.selectAppointment(appointmentDomain);
  } catch (e: unknown) {
    danger("Error get schedule", e);

    scheduleStore.appointment = null;
  } finally {
    scheduleStore.isLoading = false;
  }

  return appointmentDomain;
}

export default getAppointmentsAH;
